<template>
	<rmp-text tag="span" type="body-large" v-if="label" :color="colors.grey.darken1">
		<span class="mr-1">{{ label }}</span>
		<span class="error--text" v-if="required">*</span>
		<slot name="append"></slot>
	</rmp-text>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";

interface Props {
	label?: string;
	required?: boolean;
}

const { colors } = useColors();

defineProps<Props>()
</script>
